import { Model } from '@vuex-orm/core'

export default class Dataimex extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'dataimexs'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      type: this.attr(null),
      entity: this.attr(null),
      source_media_id: this.attr(null),
      status: this.attr(null),
      mime_type: this.attr(null),
      url: this.attr(null),
      content_length: this.attr(null),
      author_user_id: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Dataimex.js